import styled, { css } from 'styled-components';
import { PRIMARY_COLOR, PRIMARY_COLOR_HOVER, SECONDARY_COLOR_3, SECONDARY_COLOR_5 } from '../../const/color';
import { SubmitIcon, SubmitSmallIcon } from '../../const/icons';

export const Item = styled.label<{ active: boolean, small?: boolean, medium?: boolean, disabled?: boolean }>`
  border-radius: 2px;
  border: 1px solid ${PRIMARY_COLOR};
  overflow: hidden;
  position: relative;
  display: inline-block;
  cursor: pointer;
  
  ${props => props.medium ? css`
    width: 20px;
    height: 20px;
  ` : css`
    width: ${props.small ? 16 : 24}px;
    height: ${props.small ? 16 : 24}px;
  `}

  ${props => props.active ? css`
    background-color: ${PRIMARY_COLOR};
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: ${props.small ? 8 : 12}px;
      height: ${props.small ? 8 : 12}px;
      background: url("data:image/svg+xml,${props.small ? SubmitSmallIcon() : SubmitIcon()}");
      pointer-events: none;
    }
    &:hover {
      background-color: ${PRIMARY_COLOR_HOVER};
      border: 1px solid ${PRIMARY_COLOR_HOVER};
    }
  ` : css`
    border: 1px solid ${SECONDARY_COLOR_3};
  `}
  
  ${props => props.disabled && css`
    cursor: not-allowed;
  `}
`;

export const NativeInput = styled.input.attrs(() => ({ type: 'checkbox' }))`
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;

